import { StarIcon, UserGroupIcon } from '@heroicons/react/24/solid'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const ACTIVITIES = [1, 2, 3, 4, 5]
const ACTIVITY_ROTATION_MS = 4000
const STARS = [0, 1, 2, 3, 4]
const STATS = [1, 2, 3]

export default function PaywallSocialProof() {
  const [activityIndex, setActivityIndex] = useState(0)
  const { t } = useTranslation()

  useEffect(() => {
    const interval = setInterval(
      () => setActivityIndex((current) => (current + 1) % ACTIVITIES.length),
      ACTIVITY_ROTATION_MS,
    )

    return () => clearInterval(interval)
  }, [])

  return (
    <div className="space-y-4">
      <div className="hw-card flex items-center justify-center gap-2 px-4 py-3">
        <div className="flex">
          {STARS.map((star) => (
            <StarIcon className="text-hw-yellow h-4 w-4" key={star} />
          ))}
        </div>

        <p className="text-hw-ink text-xs font-semibold">
          {t('pages.checkout.socialProofBanner')}
        </p>
      </div>

      <div className="flex flex-wrap items-center justify-center gap-2">
        <p className="bg-hw-primary-soft text-hw-primary flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold">
          <UserGroupIcon className="h-4 w-4" />
          {t('pages.checkout.userCount')}
        </p>

        <p className="bg-hw-yellow-soft text-hw-ink rounded-full px-3 py-1.5 text-xs font-semibold">
          {t('pages.checkout.viewingNow')}
        </p>
      </div>

      <div className="border-hw-line flex items-center gap-2 rounded-full border bg-white px-3 py-2.5">
        <span className="bg-hw-green relative flex h-2 w-2 shrink-0 rounded-full">
          <span className="bg-hw-green absolute inset-0 animate-ping rounded-full" />
        </span>

        <p
          className="text-hw-muted animate-fade-in text-xs"
          key={activityIndex}
        >
          {t(
            `pages.checkout.activityFeed.activity${ACTIVITIES[activityIndex]}`,
          )}
        </p>
      </div>

      <div className="grid grid-cols-3 gap-2">
        {STATS.map((stat) => (
          <div
            className="hw-card flex flex-col items-center gap-0.5 px-2 py-3"
            key={stat}
          >
            <p className="text-hw-primary text-xl font-extrabold">
              {t(`pages.checkout.successStats.stat${stat}Value`)}
            </p>

            <p className="text-hw-muted text-center text-[11px] leading-tight">
              {t(`pages.checkout.successStats.stat${stat}Label`)}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}
